export default __webpack_public_path__ + "static/media/edit-profile-pic-icon.fdcc9885.svg";